import fetch from 'auth/FetchInterceptor'

const TagService = {
  getAll: () => fetch({ url: '/crm/tags', method: 'get' }),
  create: (data) => fetch({ url: '/crm/tags', method: 'post', data }),
  update: (id, data) =>
    fetch({ url: `/crm/tags/${id}`, method: 'patch', data }),
  remove: (id) => fetch({ url: `/crm/tags/${id}`, method: 'delete' }),
}

export default TagService
